import React from 'react'
import { Tooltip } from 'react-tooltip'

import styles from './InputGroup.module.scss'

import { InfoCircle as InfoIcon } from '../../../icons'

import ValidationMessage from '../ValidationMessage/ValidationMessage'

interface IInputGroup {
  className?: string
  labelClassName?: string
  labelTop?: string
  additionalLabel?: string
  labelLeft?: string
  description?: string | JSX.Element
  name?: string
  error?: string
  isErrored?: boolean
  bottomNotice?: string
  size?: 'm' | 'l'
  childrenDirection?: 'horizontal' | 'vertical'
  boldLabel?: boolean
  semiBoldLabel?: boolean
  children?: React.ReactNode
}

const InputGroup: React.FC<IInputGroup> = (props) => {
  const {
    className,
    labelTop,
    labelLeft,
    additionalLabel,
    labelClassName,
    size,
    error,
    isErrored,
    description,
    name,
    childrenDirection,
    children,
    bottomNotice,
    boldLabel,
    semiBoldLabel,
  } = props

  const labelSizeClass = size ? `label_${size}` : 'label_m'

  return (
    <div
      className={`
        ${styles.container}
        ${styles[labelSizeClass]}
        ${isErrored ? styles.errored : ''}
        ${className ? className : ''}
      `}
    >
      {!!labelTop && (
        <div
          className={`
            ${styles.labelTop}
            ${labelClassName ? labelClassName : ''}
          `}
        >
          <span
            className={`
              ${boldLabel ? styles.bold : ''}
              ${semiBoldLabel ? styles.semiBold : ''}
            `}
          >{labelTop}</span>

          {!!additionalLabel && <span>&nbsp;{additionalLabel}</span>}

          {!!description && (
            <div
              className={styles.infoIconWrapper}
              data-tip
              data-tooltip-id={`tooltip__${name}`}
            >
              <InfoIcon />
            </div>
          )}
        </div>
      )}

      <div className={styles.content}>
        {!!labelLeft && (
          <div
            className={`
              ${styles.labelLeft}
              ${labelClassName ? labelClassName : ''}
              ${boldLabel ? styles.bold : ''}
            `}
          >
            {labelLeft}
          </div>
        )}

        <div
          className={`
            ${styles.childrenWrapper}
            ${childrenDirection ? styles[childrenDirection] : styles.horizontal}
          `}
        >
          {children}
          {!!error && <ValidationMessage>{error}</ValidationMessage>}
          {!!bottomNotice && (
            <div className={styles.bottomNotice}>{bottomNotice}</div>
          )}
        </div>
      </div>

      <Tooltip id={`tooltip__${name}`} place={'bottom'}>
        {description}
      </Tooltip>
    </div>
  )
}

export default InputGroup
